// extracted by mini-css-extract-plugin
export default {"main":"DonationQuotation_main__ZZD7S","feedback":"DonationQuotation_feedback__vrahr","cover":"DonationQuotation_cover__JJOY8","animate":"DonationQuotation_animate__T1a-j"};